import { DataTable } from "@components/DataTable/DataTable"
import { planTermsColumns } from "./tableColumnSchema"
import type { IPlanTerms } from "@apis/accounts/types"

type TTermsProps = {
  terms: IPlanTerms[]
  isPending?: boolean
}

export const PlanTermsTable = ({ terms, isPending }: TTermsProps) => {
  return (
    <DataTable
      data={terms}
      columns={planTermsColumns}
      pending={isPending}
      condensed={true}
    />
  )
}
